import React from 'react';
const Partners: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <section className="bg-white py-24 px-6">
    <div className="max-w-4xl mx-auto space-y-6">
      {onBack && <button onClick={onBack} className="underline text-sm">Back to home</button>}
      <h2 className="text-3xl serif font-bold">Work With LeadBold</h2>
      <p className="text-lg text-slate-600 leading-relaxed">Discuss training, retreats, and capacity-building programmes tailored to your institution.</p>
      <a href="mailto:leadboldng@gmail.com" className="inline-block underline">Contact the Abuja office</a>
    </div>
  </section>
);
export default Partners;
